module.exports = __webpack_public_path__ + "img/565-42dfb3.png";